import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isIos.json';

export default cache('isIos', function isIos() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});